import {connect} from 'react-redux';

import {TimelineState} from 'VideoAudioQC/Timeline/Redux/TimelineReducer';
import {AdBreaksState} from 'VideoAudioQC/Timeline/AdBreaks/Redux/AdBreaksReducer';
import {TimelineMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import {setAdPreviewsAction} from 'VideoAudioQC/AccuratePlayer/Redux/AccuratePlayerActions';
import {
    removeAdBreaksMarkerAction,
    RemoveAdBreaksMarkerAction,
    UpdateAdBreaksMarkerAction,
    updateAdBreaksMarkerAction,
} from 'VideoAudioQC/Timeline/AdBreaks/Redux/AdBreaksActions';
import {AccuratePlayerState} from 'VideoAudioQC/AccuratePlayer/Redux/AccuratePlayerReducer';
import {toggleSelectedMarkerAction} from '../../Timeline/Redux/TimelineActions';
import AdBreaksContainer from './AdBreaksContainer';

interface TimelineStore {
    adBreaks: AdBreaksState;
    selectedMarker: TimelineState;
}

export interface State {
    timeline: TimelineStore;
    videoAudioQC: {
        accuratePlayer: AccuratePlayerState,
    },
    qcTools: {
        qcToolsMetadata: {
            allotment: number | null;
            general: {
                contentType: string,
            }
        }
    }
}

interface StateProps {
    identifier: string;
    markers: TimelineMarker[];
    selectedRowId: string;
    selectedMarkerId: string;
    adOnPlayingFrame?: TimelineMarker;
    allotment: number | null;
    contentType: string;
}

export const mapState = (state: State): StateProps => {
    const {timeline, videoAudioQC, qcTools: {qcToolsMetadata: {allotment, general: {contentType}}}} = state;
    const {selectedMarker, adBreaks} = timeline;
    
    const {
        markers,
        rowId,
    } = adBreaks;
    const {
        selectedRowId,
        selectedMarkerId,
    } = selectedMarker;
    const {accuratePlayer} = videoAudioQC;
    const {adOnPlayingFrame} = accuratePlayer;
    
    return {
        identifier: rowId,
        markers,
        selectedRowId,
        adOnPlayingFrame,
        selectedMarkerId,
        allotment,
        contentType,
    };
};

export const mapDispatch = {
    toggleSelectedMarker: toggleSelectedMarkerAction,
    previewAdBreak: setAdPreviewsAction,
    removeAdBreaksMarker: removeAdBreaksMarkerAction as RemoveAdBreaksMarkerAction,
    updateAdBreaksMarker: updateAdBreaksMarkerAction as UpdateAdBreaksMarkerAction,
};

export default connect(mapState, mapDispatch)(AdBreaksContainer);
